import { FC } from 'react';
import { useConfig } from '../../hooks/config';

const sizes: any = {
  S: 12,
  M: 20,
  L: 28,
};
const lineHeights: any = {
  S: 1,
  M: 1.3,
  L: 1.6,
};

interface iLeafProps {
  attributes: any;
  leaf: any;
}

const Leaf: FC<iLeafProps> = ({ attributes, children, leaf }) => {
  const config = useConfig();
  const fontSize = sizes[leaf.size ?? 'M'];
  const lineHeight = lineHeights[leaf.lineheight ?? 'M'];
  const fontFamily =
    config.options?.families?.find((family) => family.family === leaf.family)?.name ??
    leaf.family ??
    config.options?.families?.[0]?.name;
  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  void fontFamily;

  return (
    <span {...attributes} style={{ fontSize, lineHeight }}>
      {children}
    </span>
  );
};

export default Leaf;
